import { useMemo } from 'react'
import { Plus } from 'lucide-react'
import { useTelegramBackButton } from '../../hooks/useTelegramBackButton'
import {
  useCostCalculatorStore,
  totalCost,
  countedRows,
  CostRowItem,
  CostTotals,
} from '@features/cost-calculator'
import './CostCalculatorPage.css'

/**
 * Расчёт себестоимости изделия: таблица продуктов с фасовкой, ценой упаковки
 * и расходом. Продукт выбирается из заготовленного списка или вписывается
 * вручную. Черновик сохраняется автоматически.
 */
const CostCalculatorPage = () => {
  useTelegramBackButton(true)
  // Селекторы по одному полю: иначе страница перерисовывалась бы на любое
  // изменение стора, включая соседние поля.
  const rows = useCostCalculatorStore(s => s.rows)
  const dessertName = useCostCalculatorStore(s => s.dessertName)
  const setDessertName = useCostCalculatorStore(s => s.setDessertName)
  const updateRow = useCostCalculatorStore(s => s.updateRow)
  const pickProduct = useCostCalculatorStore(s => s.pickProduct)
  const addRow = useCostCalculatorStore(s => s.addRow)
  const removeRow = useCostCalculatorStore(s => s.removeRow)
  const reset = useCostCalculatorStore(s => s.reset)

  const total = useMemo(() => totalCost(rows), [rows])
  const counted = useMemo(() => countedRows(rows), [rows])

  // safe-area-inset на корень не вешаем: шелл уже оборачивает роутинг в этот
  // класс, а повторный перебил бы наш padding-bottom нулём и спрятал итог
  // под нижним меню.
  return (
    <div className="cost-calculator-page">
      <div className="cost-calculator-body">
        <h1 className="cost-calculator-title">Себестоимость</h1>
        <p className="cost-calculator-subtitle">
          Добавьте продукты, укажите фасовку, цену упаковки и расход — посчитаем,
          во сколько обходится изделие.
        </p>

        <input
          className="cost-calculator-dessert"
          value={dessertName}
          onChange={e => setDessertName(e.target.value)}
          placeholder="Название десерта (необязательно)"
          aria-label="Название десерта"
        />

        <div className="cost-calculator-rows">
          {rows.map((row, index) => (
            <CostRowItem
              key={row.id}
              row={row}
              index={index}
              onChange={patch => updateRow(row.id, patch)}
              onPickProduct={(name, unit) => pickProduct(row.id, name, unit)}
              onRemove={() => removeRow(row.id)}
            />
          ))}
        </div>

        <button type="button" className="cost-calculator-add" onClick={addRow}>
          <Plus size={18} aria-hidden />
          Добавить продукт
        </button>

        <CostTotals total={total} counted={counted} totalRows={rows.length} />

        <button type="button" className="cost-calculator-reset" onClick={reset}>
          Очистить расчёт
        </button>
      </div>
    </div>
  )
}

export default CostCalculatorPage
